import React from 'react';
import config from '../../../../shared/services/config';
import { SearchInput } from './search-input';
import { NOOP, EMPTY_STRING } from '../../../../shared/utils/common';
import { useBreakpoint } from '../../../../shared/hooks/useBreakpoint';

export const PageHeader = ({ title, subTitle, hideSearch, searchTerm, searchPlaceholder = EMPTY_STRING, onSearchTermChange = NOOP }) => {
  const UI = config.get('uiv2', {})
  const isMobile = useBreakpoint('m')
  const parentGridProps = hideSearch ? {
    cols: 1
  } : {
    cols: 1,
    mCols: 1,
    dCols: 2
  }
  return <UI.Grid {...parentGridProps}>
    <UI.GridItem className={hideSearch ? 'tw-text-center' : ''}>
      <UI.Typography variant='H2' weight='semi-bold' className='tw-text-gray-700 tw-mb-8'>
        {title}
      </UI.Typography>
      <UI.Typography variant='P1' className='tw-text-gray-80 tw-pb-16'>
        {subTitle}
      </UI.Typography>
    </UI.GridItem>
    <UI.GridItem>
      {!hideSearch ? <div className='tw-flex tw-flex-row-reverse'>
        <SearchInput
          value={searchTerm}
          placeholder={searchPlaceholder}
          onChange={onSearchTermChange}
          isRounded={!isMobile}
          fullWidth={isMobile}
        />
      </div> : null}
    </UI.GridItem>
  </UI.Grid>
}


export const PageHeaderLoader = () => {
  const UI = config.get('uiv2', {})

  return <UI.Grid cols={2} gap={24} className='tw-px-8'>
    <UI.GridItem>
      <div className='tw-flex tw-gap-24 tw-text-gray-700 tw-my-24 tw-pb-24'>
        <UI.Skeleton />
        <UI.Skeleton />
      </div>
      <UI.Skeleton />
    </UI.GridItem>
    <UI.GridItem>
      <UI.Grid cols={2} gap={24}>
        <UI.GridItem colStart={2}>
          <UI.Skeleton />
        </UI.GridItem>
      </UI.Grid>
    </UI.GridItem>
  </UI.Grid>
}